/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 *
 * @author Vladislav Oshkanov
 * @author Yakov Gushchin
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '@/main/theme';

import { LinkTextBlock } from '../../LinkBlock/styled/LinkStyled';

const DropContainerStyled = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-left: 8px;

    & .drop-filters-button__link {
        margin-left: 8px;

        ${LinkTextBlock} {
            ${fonts.textMainBold};
            color: ${colors.linkDefaultColor};
        }
    }

    & .drop-filters-button__link .text-block {
        line-height: 1;
    }
`;

export {
    DropContainerStyled,
};
